export const ProjectManagementIcon = ({ useOriginalColor }) => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.257812 1.94422C0.257812 0.870457 1.12827 0 2.20203 0H14.4051C15.4788 0 16.3493 0.870457 16.3493 1.94422C16.3493 3.01798 15.4788 3.88844 14.4051 3.88844H2.20203C1.12827 3.88844 0.257812 3.01798 0.257812 1.94422Z"
      fill={useOriginalColor ? "#009AFF" : "currentColor"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.9082 8.72938C5.9082 7.65561 6.77866 6.78516 7.85242 6.78516H20.0554C21.1292 6.78516 21.9997 7.65561 21.9997 8.72938C21.9997 9.80314 21.1292 10.6736 20.0554 10.6736H7.85242C6.77866 10.6736 5.9082 9.80314 5.9082 8.72938Z"
      fill={useOriginalColor ? "#009AFF" : "currentColor"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 15.5126C0 14.4388 0.870457 13.5684 1.94422 13.5684H14.1472C15.221 13.5684 16.0915 14.4388 16.0915 15.5126C16.0915 16.5863 15.221 17.4568 14.1472 17.4568H1.94422C0.870457 17.4568 0 16.5863 0 15.5126Z"
      fill={useOriginalColor ? "#009AFF" : "currentColor"}
    />
  </svg>
);
